export default __webpack_public_path__ + "static/media/cartao-mastercard.b2211a68.svg";